import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Banner from "./components/banner/Banner";
import Footer from "./components/contact/Footer";
import Features from "./components/features/Features";
import Navbar from "./components/navbar/Navbar";
import Resume from "./components/resume/Resume";
import NewProjects from "./components/newProjects/NewProjects";
import AnimatedAppLoader from "./components/AnimatedAppLoader";

function App() {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoader(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="w-full min-h-screen bg-[#212428] [overflow-x:clip]">
      <AnimatePresence mode="wait">
        {loader ? (
          <motion.div
            key="loader"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              position: "absolute",
              width: "100%",
              top: 0,
              left: 0,
              zIndex: 10,
              backgroundColor: "#222428", // Ensures background stays consistent
            }}
          >
            <div className="flex items-center justify-center">
              <AnimatedAppLoader />
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="w-full text-lightText"
            style={{
              position: "relative",
              zIndex: 1,
            }}
          >
            <Navbar />
            <Banner />
            <div className="max-w-screen-xl mx-auto px-4">
              <Features />
              <NewProjects />
              <Resume />
              <Footer />
              {/* <Chatbot /> */}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
